module.exports = __webpack_public_path__ + "static/media/knack.0219bd4c.png";